import React from 'react';
import { Button } from '@mui/material';

const CustomButton = ({
  children,
  variant = 'contained',
  color = 'primary',
  sx = {},
  ...props
}) => {
  const baseStyle = {
    textTransform: "none",
    fontWeight: "bold",
    borderRadius: 2,
    transition: 'all 0.2s ease-in-out',
  };

  let variantStyle = {};

  if (variant === 'contained') {
    if (color === 'primary') {
      variantStyle = {
        py: 1,
        px: 3,
        boxShadow: '0px 4px 12px rgba(74, 102, 241, 0.3)',
        backgroundColor: 'rgba(74, 102, 241, 1)',
        color: '#FFFFFF',
        '&:hover': {
          boxShadow: '0px 6px 16px rgba(74, 102, 241, 0.4)',
          transform: 'translateY(-1px)',
          backgroundColor: 'rgba(74, 102, 241, 0.9)',
        },
        '&:disabled': {
          backgroundColor: 'rgba(74, 102, 241, 0.5)',
          color: '#FFFFFF',
          boxShadow: 'none',
        }
      };
    } else if (color === 'secondary') {
      variantStyle = {
        py: 1,
        px: 3,
        boxShadow: '0px 4px 12px rgba(156, 39, 176, 0.3)',
        backgroundColor: '#9C27B0',
        color: '#FFFFFF',
        '&:hover': {
          boxShadow: '0px 6px 16px rgba(156, 39, 176, 0.4)',
          transform: 'translateY(-1px)',
          backgroundColor: '#7B1FA2',
        },
        '&:disabled': {
          backgroundColor: 'rgba(156, 39, 176, 0.5)',
          color: '#FFFFFF',
          boxShadow: 'none',
        }
      };
    }
  } else if (variant === 'outlined') {
    if (color === 'primary') {
      variantStyle = {
        fontWeight: 500,
        px: 2,
        py: 1,
        borderColor: "#E0E0E0",
        color: "#616161",
        backgroundColor: "transparent",
        '&:hover': {
          borderColor: "rgba(74, 102, 241, 0.5)",
          color: "rgba(74, 102, 241, 1)",
          backgroundColor: "rgba(74, 102, 241, 0.08)",
        },
      };
    } else if (color === 'secondary') {
      variantStyle = {
        py: 1,
        px: 2,
        borderColor: '#9C27B0',
        color: '#9C27B0',
        minWidth: "140px",
        backgroundColor: "transparent",
        '&:hover': {
          borderColor: '#7B1FA2',
          backgroundColor: '#F3E5F5',
          borderWidth: '2px',
        },
        '&:disabled': {
          borderColor: 'rgba(156, 39, 176, 0.5)',
          color: 'rgba(156, 39, 176, 0.5)',
        }
      };
    }
  }

  return (
    <Button
      variant={variant}
      sx={{ ...baseStyle, ...variantStyle, ...sx }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
